export type DrawingCanvas = OffscreenCanvas | HTMLCanvasElement
export type DrawingContext2D = OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D

export function createDrawingCanvas(width: number, height: number): DrawingCanvas {
  const safeWidth = Math.max(1, Math.round(width))
  const safeHeight = Math.max(1, Math.round(height))
  if (typeof OffscreenCanvas === 'function') {
    try { return new OffscreenCanvas(safeWidth, safeHeight) }
    catch { /* fall through to a document canvas */ }
  }
  if (typeof document === 'undefined') throw new Error('2D canvas is unavailable')
  const canvas = document.createElement('canvas')
  canvas.width = safeWidth
  canvas.height = safeHeight
  return canvas
}

export function getDrawingContext2d(
  canvas: DrawingCanvas,
  options?: CanvasRenderingContext2DSettings,
): DrawingContext2D {
  const context = canvas.getContext('2d', options)
  if (!context) throw new Error('2D canvas is unavailable')
  return context as DrawingContext2D
}
